exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".videoOps--col---K_wl5Mz {\r\n  margin-top: 36px;\r\n  text-align: center;\r\n}\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/opportunity/videoOps/videoOps.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;CACpB","file":"videoOps.css","sourcesContent":[".col {\r\n  margin-top: 36px;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"col": "videoOps--col---K_wl5Mz"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/opportunity/videoOps/videoOps.css
// module id = 401
// module chunks = 0